import { useEffect, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface DialogOverlayProps {
  open: boolean
  onClose: () => void
  children: ReactNode
}

export default function DialogOverlay({ open, onClose, children }: DialogOverlayProps) {
  useEffect(() => {
    if (!open) return
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKey)

    return () => {
      document.body.style.overflow = prev
      window.removeEventListener('keydown', onKey)
    }
  }, [open, onClose])

  if (!open) return null

  return createPortal(
    <div className="dialog-overlay" onClick={onClose}>
      <div className="dialog-overlay__inner" onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </div>,
    document.body
  )
}
